<template>
	<form @submit.prevent="resetPassword()">
		<h4 class="mb-4 f-w-400 text-center">Change your password</h4>
		<!-- <div class="alert alert-info mb-4">
			<strong
				>A 6 digits code has been sent to {{ userEmail }}, please check your
				email for the code.</strong
			>
		</div> -->
		<div class="form-group mb-3">
			<label for="code">
				Enter code received in your email <span class="text-danger">*</span>
			</label>
			<input
				v-model="form.code"
				type="text"
				class="form-control"
				id="code"
				placeholder=""
				required
			/>
			<span class="text-danger">Code was sent to {{ userEmail }}</span>
		</div>
		<div class="form-group mb-3">
			<label for="password">
				New Password <span class="text-danger">*</span>
			</label>
			<input
				v-model="form.password"
				type="password"
				class="form-control"
				id="password"
				placeholder=""
				required
			/>
		</div>
		<div class="form-group mb-4">
			<label for="password_confirmation">Re-Type New Password</label>
			<input
				v-model="form.password_confirmation"
				type="password"
				class="form-control"
				id="password_confirmation"
				placeholder=""
				required
			/>
		</div>
		<div class="form-group">
			<LoadingButton
				class="btn btn-block btn-info mb-4"
				style="width: 100%; margin: 0"
				>Reset Password</LoadingButton
			>
			<p class="mb-0 text-center text-muted">
				<a href="/login" class="f-w-400 text-primary">Back to login</a>
			</p>
		</div>
	</form>
</template>
<script>
import LoadingButton from "@/components/LoadingButton.vue";
import { mapActions, mapGetters } from "vuex";

export default {
	components: {
		LoadingButton,
	},

	data() {
		return {
			form: {
				code: null,
				email: null,
				password: null,
				password_confirmation: null,
			},
		};
	},

	computed: {
		...mapGetters({
			userEmail: "auth/userEmail",
		}),
	},

	watch: {
		userEmail(val) {
			this.form.email = val;
		},
	},

	methods: {
		...mapActions({
			ResetPassword: "auth/ResetPassword",
		}),

		resetPassword() {
			this.ResetPassword(this.form).then((response) => {
				if (response === "success") {
					this.$router
						.push("/login")
						.then(() => {})
						// .then(() => location.reload())
						.catch(() => {});
				}
			});
		},
	},
	mounted() {
		this.form.email = this.userEmail;
	},
};
</script>
<style scoped>
.form-control {
	padding: 5px 10px;
}
</style>
